import { useTranslation } from 'react-i18next'
import { Checkbox } from '@/components/shadcn/checkbox'
import { Label } from '@/components/shadcn/label'

interface Props {
  sendPush: boolean
  onSendPushChange: (value: boolean) => void
}

export function NotificationPush({ sendPush, onSendPushChange }: Props) {
  const { t } = useTranslation('notifications')

  return (
    <div className="flex flex-col gap-2">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{t('dialog.push.title')}</p>
      <div className="flex items-center gap-2">
        <Checkbox
          id="send-push"
          checked={sendPush}
          onCheckedChange={(v) => onSendPushChange(v === true)}
        />
        <Label htmlFor="send-push" className="cursor-pointer font-normal text-sm">{t('dialog.push.send')}</Label>
      </div>
    </div>
  )
}
